// src\store\modifJson\procedureReducer.js
import {
    FETCH_PROCEDURE_DATA_REQUEST,
    FETCH_PROCEDURE_DATA_SUCCESS,
    FETCH_PROCEDURE_DATA_FAILURE,
    SAVE_PROCEDURE_DATA_REQUEST,
    SAVE_PROCEDURE_DATA_SUCCESS,
    SAVE_PROCEDURE_DATA_FAILURE,
    UPDATE_STAGES,
    ADD_STEP_REQUEST,
    ADD_STEP_SUCCESS,
    ADD_STEP_FAILURE,
    SET_SETTINGS
} from '../modifJson/procedureActions'; // Ajustez le chemin si nécessaire

// src/store/modifJson/procedureReducer.js
const initialState = {
    data: null,
    loading: false,
    error: null,
    currentFolderName: null,
    currentFilename: null,
    stages: [],
    steps: [], // Nouvel état pour la liste des étapes
};

const procedureReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PROCEDURE_DATA_REQUEST:
            return { ...state, loading: true, error: null, data: null, currentFolderName: null, currentFilename: null, stages: [], steps: [] };
        case FETCH_PROCEDURE_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data,
                currentFolderName: action.payload.folderName,
                currentFilename: action.payload.filename,
                stages: action.payload.process?.stages || [],
                steps: action.payload.process?.steps || [], // Stockez la liste des étapes
            };
        case FETCH_PROCEDURE_DATA_FAILURE:
            return { ...state, loading: false, error: action.payload, data: null, currentFolderName: null, currentFilename: null, stages: [], steps: [] };
        case ADD_STEP_REQUEST:
            return { ...state, loading: true, error: null };
        case ADD_STEP_SUCCESS:
            return {
                ...state,
                loading: false,
                data: {
                    ...state.data,
                    process: {
                        ...state.data.process,
                        steps: [...state.data.process.steps, action.payload]
                    }
                },
                steps: [...state.steps, action.payload]
            };
        case ADD_STEP_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SAVE_PROCEDURE_DATA_REQUEST:
            return { ...state, loading: true, error: null };
        case SAVE_PROCEDURE_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                stages: action.payload.process?.stages || [],
                steps: action.payload.process?.steps || [],
                currentFolderName: action.payload.process?.urlFolderName || state.currentFolderName,
                currentFilename: `${action.payload.process?.urlFolderName}.json`,
                error: null
            };
        case SAVE_PROCEDURE_DATA_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case SET_SETTINGS:
            return {
                ...state,
                data: {
                    ...state.data,
                    settings: action.payload,
                },
            };
        default:
            return state;
    }
};

export default procedureReducer;


//Creators : Florian Cohen-Joly @3DDGAMES -- Under license